import gql from 'graphql-tag';

export const CREATE_TABLE_FILTER = gql`
  mutation CreateTableFilter($input: CreateTableFilterInput!) {
    tableFilter {
      result: createFilter(input: $input) {
        error
        success
      }
    }
  }
`;
